// extracted by mini-css-extract-plugin
export default {"btn":"workRemards_btn__DBgCA","input":"workRemards_input__0TeQ-","icon":"workRemards_icon__ahFQq","box":"workRemards_box__g7zJ0"};